import { serviceSSO, trainingServe, SysToken } from "./request";

// Calling token API
export const userLogin = (data) => {
  return serviceSSO({
    url: `auth/realms/SimplifyCV/protocol/openid-connect/token`, // hire3x-dev SimplifyCV
    method: "post",
    data,
  });
};
export const userLogOut = (data, headers) => {
  return serviceSSO({
    url: `auth/realms/SimplifyCV/protocol/openid-connect/logout`, //SimplifyCV hire3x-dev
    method: "post",
    headers: headers,
    data,
  });
};

// Sign In
export const signIn = (data) => {
  return trainingServe({
    url: `candidate/authentication/?email=${data}`,
    method: "get",
  });
};

// Register
export const register = (data) => {
  return trainingServe({
    url: `candidate/authentication/`,
    method: "post",
    data,
  });
};

// Forgot Password?
export const forgotPassword = (email) => {
  return SysToken({
    url: `forgot-password/?email=${email}`,
    method: "get",
  });
};

//All Market Place Courses
export const getMaketPlace = (data) => {
  return trainingServe({
    url: `marketplace/courses/`,
    method: "post",
    data,
  });
};

//For getting Stars and instructor info Of each category
export const getMaketPlaceCategory = (data) => {
  return trainingServe({
    url: `marketplace/courses/`,
    method: "post",
    data,
  });
};
// For getting course Stats
export const getcourseStats = (payload) => {
  return trainingServe({
    url: `candidate/course-stats/`,
    method: "get",
    params: {
      courseID: payload.courseID,
    },
  });
};

//Get all the Popular Categories List
export const getPopularCategories = (payload) => {
  return trainingServe({
    url: `hire3x/categories`,
    method: "get",
    params: {
      count: payload.count,
      searchQuery: payload.searchQuery,
      courseCountRequired: payload.courseCountRequired,
      popularCategories: payload.popularCategories,
    },
  });
};

export const getFeaturedCategories = (payload) => {
  return trainingServe({
    url: `hire3x/categories`,
    method: "get",
    params: {
      count: payload.count,
      searchQuery: payload.searchQuery,
      featuredCategories: payload.featuredCategories,
      page: payload.page,
    },
  });
};

//for getting course instructor details
export const getCourseInstructor = (data) => {
  return trainingServe({
    url: `marketplace/instructor-info/`,
    method: "get",
    params: {
      instructorUserID: data,
    },
  });
};

//for getting course ratings
export const getCourseRatings = (data) => {
  return trainingServe({
    url: `marketplace/rating/`,
    method: "get",
    params: {
      referenceID: data.referenceID,
      count: data.count,
      page: data.page,
      // getSummaryInfo: true,
    },
  });
};
export const publicUserData = (code) => {
  return trainingServe({
    url: "candidate/certificate-hash/?certificateHash=" + code,
    method: "get",
  });
};
//for getting particular course details
export const getParticularCourseDetails = (data) => {
  return trainingServe({
    url: `marketplace/preview-course/`,
    method: "post",
    data,
  });
};

// Add to wishlist
export const addtoWishlist = (data) => {
  return trainingServe({
    url: `marketplace/wishlist/`,
    method: "post",
    data,
  });
};

// get all wishlist data in wishlist page
export const getAllWishlist = (data) => {
  return trainingServe({
    url: `marketplace/wishlist/`,
    method: "get",
    params: {
      count: data.count,
      page: data.page,
    },
  });
};

// remove wishlist
export const removetoWishlist = (data) => {
  return trainingServe({
    url: `marketplace/wishlist/`,
    method: "delete",
    data,
  });
};

//for liking and disliking the reviews
export const likeDislike = (data) => {
  return trainingServe({
    url: `marketplace/rating/`,
    method: "put",
    data,
  });
};

export const addToCartPost = (data) => {
  return trainingServe({
    url: `marketplace/cart/`,
    method: "post",
    data,
  });
};

export const getAllCart = () => {
  return trainingServe({
    url: `marketplace/cart/`,
    method: "get",
  });
};

export const removeCart = (data) => {
  return trainingServe({
    url: `marketplace/cart/`,
    method: "delete",
    data,
  });
};

// get all section Without Content
export const getCourseInfoWithSections = (data) => {
  return trainingServe({
    url: `candidate/preview-course/?courseID=${data.courseID}&isSectionsRequired=true`,
    method: "get",
  });
};

// get specific lesson details and content
export const getLessonWithContent = (data) => {
  return trainingServe({
    url: `/candidate/preview-course/?courseID=${data.courseID}&lessonInfo=true&lessonID=${data.lessonID}`,
    method: "get",
  });
};

// Lesson Completion Log
export const completeLesson = (data) => {
  return trainingServe({
    url: `candidate/lesson-completion-controller/`,
    method: "post",
    data,
  });
};

export const getCourseDetails = (data) => {
  return trainingServe({
    url: `candidate/my-course/`,
    method: "post",
    data,
  });
};
export const getAuthors = (data) => {
  return trainingServe({
    url: `candidate/my-course/?author=true&searchQuery=${data.searchQuery}&page=${data.page}&count=${data.count}`,
    method: "get",
    data,
  });
};
export const getCategories = (data) => {
  return trainingServe({
    url: `candidate/my-course/?category=true&searchQuery=${data.searchQuery}&page=${data.page}&count=${data.count}`,
    method: "get",
    data,
  });
};

// starting the quiz
export const startQuiz = (data) => {
  return trainingServe({
    url: `quiz/quiz-response/`,
    method: "post",
    data,
  });
};

// get the quiz questions
export const getQuiz = (data) => {
  return trainingServe({
    url: `quiz/quiz-response/?responseID=${data}`,
    method: "get",
    data,
  });
};

// answer the quiz questions
export const answerQues = (data) => {
  return trainingServe({
    url: `quiz/quiz-response/`,
    method: "put",
    data,
  });
};

// submit the quiz
export const submitQuiz = (data) => {
  return trainingServe({
    url: `quiz/quiz-marking/`,
    method: "post",
    data,
  });
};

// get the quiz questions with result
export const getQuizResult = (data) => {
  return trainingServe({
    url: `quiz/quiz-marking/?responseID=${data}`,
    method: "get",
    data,
  });
};
export const setReminder = (data) => {
  return trainingServe({
    url: `candidate/course-reminder/`,
    method: "post",
    data,
  });
};
// get cart summary
export const getCartSummary = (promo) => {
  const summary = {
    url: `marketplace/cart-summary/`,
    method: "get",
  };
  if (promo) {
    summary["params"] = {
      promoCode: promo,
    };
  }
  return trainingServe(summary);
};

//verify Coupon
export const getVerifyCoupon = (data) => {
  return trainingServe({
    url: `marketplace/coupon-verify/`,
    method: "get",
    params: {
      promoCode: data.promoCode,
    },
  });
};
export const getoverallProgress = () => {
  return trainingServe({
    url: `candidate/overall-progress-controller/`,
    method: "post",
  });
};
export const getcandidateInfo = () => {
  return trainingServe({
    url: `/candidate/candidate-info/`,
    methods: "post",
  });
};

//search history
export const getSearchHistory = (data) => {
  return trainingServe({
    url: `marketplace/candidate-course-logs/`,
    method: "get",
    params: data,
  });
};

//remove search history
export const removeSearchHistory = (data) => {
  return trainingServe({
    url: `marketplace/candidate-course-logs/`,
    method: "delete",
    data,
  });
};

//Certificates APIs
export const getOngoingCourses = () => {
  return trainingServe({
    url: "candidate/my-course/",
    method: "post",
    data: {
      completed: false,
    },
  });
};

export const getCompletedCourses = () => {
  return trainingServe({
    url: "candidate/my-course/",
    method: "post",
    data: {
      completed: true,
    },
  });
};

export const addCourseToWishlist = (courseID) => {
  return trainingServe({
    url: `marketplace/wishlist/`,
    method: "post",
    data: {
      itemID: courseID,
    },
  });
};

export const removeCourseFromWishlist = (courseID) => {
  return trainingServe({
    url: `marketplace/wishlist/`,
    method: "delete",
    data: {
      itemID: courseID,
    },
  });
};

export const getPublicCertificate = (data) => {
  return trainingServe({
    url: `candidate/public-candidate-certificate/`,
    method: "get",
    params: data,
  });
};

export const previewCourse = (data) => {
  return trainingServe({
    url: `marketplace/preview-course/`,
    method: "post",
    data,
  });
};

//get search for courses and instructors
export const getSearch = (data) => {
  return trainingServe({
    url: `marketplace/top-search/?searchQuery=${data}`,
    method: "get",
  });
};

// get course counts
export const getCourseCounts = (data) => {
  return trainingServe({
    url: `common/course-counts/?courseID=${data}`,
    method: "get",
  });
};

//get sub-categories
export const getSubCategories = (data) => {
  return trainingServe({
    url: `hire3x/categories`,
    method: "get",
    params: data,
  });
};

// get threads
export const getThreads = (data) => {
  return trainingServe({
    url: `community/thread-controller/`,
    method: "get",
    params: {
      referenceID: data.courseID,
      count: data.count,
      page: data.page,
      searchQuery: data.searchQuery,
      getCommentsInfo: true,
    },
  });
};

//post thread
export const postThread = (data) => {
  return trainingServe({
    url: `community/thread-controller/`,
    method: "post",
    data,
  });
};

//like a thread
export const likeThread = (data) => {
  return trainingServe({
    url: `community/thread-controller/`,
    method: "patch",
    data,
  });
};

//dislike a thread
export const dislikeThread = (data) => {
  return trainingServe({
    url: `community/thread-controller/`,
    method: "patch",
    data,
  });
};

//get comments for a thread
export const getComments = (data) => {
  return trainingServe({
    url: `community/threadcomments-controller/`,
    method: "get",
    params: {
      threadID: data.threadID,
      count: data.count,
      page: data.page,
      getCommentsInfo: true,
      searchQuery: data.searchQuery,
    },
  });
};

//post a comment
export const postComment = (data) => {
  return trainingServe({
    url: `community/threadcomments-controller/`,
    method: "post",
    data,
  });
};

//like a thread
export const likeComment = (data) => {
  return trainingServe({
    url: `community/threadcomments-controller/`,
    method: "patch",
    data,
  });
};

//dislike a thread
export const dislikeComment = (data) => {
  return trainingServe({
    url: `community/threadcomments-controller/`,
    method: "patch",
    data,
  });
};

//get replies to comments
export const getReplies = (data) => {
  return trainingServe({
    url: `community/commentsreply-controller/`,
    method: "get",
    params: {
      commentID: data.commentID,
      count: data.count,
      page: data.page,
      searchQuery: data.searchQuery,
    },
  });
};

//post a reply
export const postReply = (data) => {
  return trainingServe({
    url: `community/commentsreply-controller/`,
    method: "post",
    data,
  });
};

//like a reply
export const likeReply = (data) => {
  return trainingServe({
    url: `community/commentsreply-controller/`,
    method: "patch",
    data,
  });
};

//dislike a reply
export const dislikeReply = (data) => {
  return trainingServe({
    url: `community/commentsreply-controller/`,
    method: "patch",
    data,
  });
};

//Instructor APIs
export const getInstructorDetails = (id) => {
  return trainingServe({
    url: `marketplace/instructor-info`,
    method: "get",
    params: {
      instructorID: id,
    },
  });
};

export const getInstructorCourses = (id) => {
  return trainingServe({
    url: `marketplace/courses/`,
    method: "post",
    data: {
      instructorID: id,
      ratingSummaryInfo: "true",
      wishlistInfo: "true",
      instructorInfo: "true",
    },
  });
};

//purchase course
export const purchaseCourse = (data) => {
  return trainingServe({
    url: `candidate/course-enrollment/`,
    method: "post",
    data,
  });
};

//get popular instructors
export const getPopularInstructors = (data) => {
  return trainingServe({
    url: `marketplace/popularInstructors/`,
    method: "get",
    params: {
      page: data.page,
      count: data.count,
    },
  });
};

export const getLanguages = (data) => {
  return trainingServe({
    url: `hire3x/language-controller/`,
    method: "get",
    params: data,
  });
};
